import React from "react";
import { createListTableColumns, ListTableColumn, renderDate, renderTextWithTooltip } from "sprint-common-web";

import { renderActionStatus } from "../../../../../../common/utils/renderActionStatus";
import { ProcessRejectCloudFileItem } from "./RejectCloudFileItem";

export const createRejectCloudFilesColumns = (): ListTableColumn<ProcessRejectCloudFileItem>[] => {
    return createListTableColumns<ProcessRejectCloudFileItem>([
        {
            type: "basic",
            key: "filename",
            name: "File name",
            minWidth: 150,
            maxWidth: 200,
            onRender: renderTextWithTooltip
        },
        {
            type: "basic",
            key: "filePath",
            name: "File path",
            minWidth: 150,
            maxWidth: 300,
            onRender: renderTextWithTooltip
        },
        {
            type: "basic",
            key: "reference",
            name: "Reference",
            minWidth: 100,
            maxWidth: 150
        },
        {
            type: "basic",
            key: "originator",
            name: "Originator",
            minWidth: 150,
            maxWidth: 150
        },
        {
            type: "basic",
            key: "arrivalDate",
            name: "Arrival date",
            minWidth: 150,
            maxWidth: 150,
            onRender: renderDate
        },
        {
            type: "basic",
            key: "processStatus",
            name: "Process status",
            minWidth: 100,
            onRender: renderActionStatus
        }
    ]);
};
